module.exports = __webpack_public_path__ + "public/img/duty1.206911bc.png";